import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Footer } from "@faire/retailer-visitor-shared/components/Footer/index";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { PageInitialized } from "@faire/retailer-visitor-shared/events";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { useEffectAssignWhen } from "@faire/retailer-visitor-shared/settings/useEffectAssignWhen";
import { useAssignSettingLoggedOutHomepageRedesignV2, useIsLoggedOutHomepageRedesignV2, useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { BestsellerProductsCarousel } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BestsellerProductsCarousel/BestsellerProductsCarousel";
import { BestsellersBanner } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BestsellersBanner/BestsellersBanner";
import { BigVideoHeaderBanner } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BigVideoHeaderBanner/BigVideoHeaderBanner";
import { BlogCarousel } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BlogCarousel/BlogCarousel";
import { BottomSignUpBanner } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/BottomSignUpBanner";
import { BrandValueBannerWithV2Design } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BrandValueBannerV2/BrandValueBannerWithV2Design";
import { CategoryBestBrandsWithV2Design } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/CategoryBestBrandsBannerV2/CategoryBestBrandsWithV2Design";
import { ForAnyRetailerBanner } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/ForAnyRetailerBanner/ForAnyRetailerBanner";
import { TopHeaderBanner } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/TopHeaderBanner/TopHeaderBanner";
import { WeMakeItSimpleBanner } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/WeMakeItSimpleBanner/WeMakeItSimpleBanner";
import { useCategoryBrandsBannerQuery } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/DataFetching/useCategoryBrandsBannerQuery";
import { RenderWithBuilder } from "@faire/web--source/builder/BuilderComponents/RenderWithBuilder";
import { markPageJsExecuted } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { useUserPerceivedLoadTimingWithKey } from "@faire/web--source/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import { trackRetailersPageViewView } from "@faire/web-api--source/events/retailers/view/pageView";
import { ENABLE_HOMEPAGE_LOCALIZED_CONTENT_241015 } from "@faire/web-api--source/indigofair/settings/ENABLE_HOMEPAGE_LOCALIZED_CONTENT_241015";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
var PAGE_JS_EXECUTED_MARK = markPageJsExecuted();
export var LoggedOutHomePageBase = function(param) {
    var builderPromise = param.builderPromise;
    var assignSettingHomePageRedesignV2 = useAssignSettingLoggedOutHomepageRedesignV2();
    var _useCategoryBrandsBannerQuery = useCategoryBrandsBannerQuery(), isFetching = _useCategoryBrandsBannerQuery.isFetching, dataUpdatedAt = _useCategoryBrandsBannerQuery.dataUpdatedAt;
    var loadTimingRef = useUserPerceivedLoadTimingWithKey({
        name: "page-home-logged-out",
        pageLoadKey: "page-home-logged-out-redesign",
        numComponents: 2,
        isPageLoading: isFetching,
        pageJsExecutedMark: PAGE_JS_EXECUTED_MARK,
        enableTrackPerformanceBreakdown: "internal-tracking",
        dataUpdatedAt: dataUpdatedAt
    });
    var pathname = useLocation().pathname;
    var ref = useDoActionWhenVisible(function() {
        return trackRetailersPageViewView("", "", "", "home", pathname, "page-home-logged-out-redesign");
    });
    var countryCode = getSessionCountry();
    useEffectAssignWhen(ENABLE_HOMEPAGE_LOCALIZED_CONTENT_241015, countryCode === "FRA" || countryCode === "GBR");
    useEffect(function() {
        assignSettingHomePageRedesignV2();
    }, [
        assignSettingHomePageRedesignV2
    ]);
    var isHomepageRedesignV2 = useIsLoggedOutHomepageRedesignV2();
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    useEffect(function() {
        PageInitialized.publish();
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            background: "#FBF8F6",
            width: "100%"
        },
        ref: ref,
        children: [
            builderPromise ? /*#__PURE__*/ _jsx(BigVideoHeaderBanner, {
                builderPromise: builderPromise,
                loadTimingRef: loadTimingRef
            }) : /*#__PURE__*/ _jsx(TopHeaderBanner, {
                loadTimingRef: loadTimingRef
            }),
            /*#__PURE__*/ _jsx(CategoryBestBrandsWithV2Design, {
                loadTimingRef: loadTimingRef
            }),
            isHomepageRedesignV2 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SlideIn, {
                        offset: getSpacing("3x"),
                        children: /*#__PURE__*/ _jsx(RenderWithBuilder, {
                            modelName: "logged-out-homepage-were-faire-banner",
                            onViewEvent: function() {
                                trackLoggedOutRetailersLoggedOutHomeRedesignView("were_faire_banner", "".concat(homepageRedesignVariant));
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
                        children: /*#__PURE__*/ _jsx(BestsellerProductsCarousel, {})
                    }),
                    /*#__PURE__*/ _jsx(ForAnyRetailerBanner, {}),
                    /*#__PURE__*/ _jsx(SlideIn, {
                        offset: getSpacing("3x"),
                        children: /*#__PURE__*/ _jsx(RenderWithBuilder, {
                            modelName: "logged-out-homepage-explore-categories-carousel",
                            onViewEvent: function() {
                                trackLoggedOutRetailersLoggedOutHomeRedesignView("explore_categories_carousel", "".concat(homepageRedesignVariant));
                            }
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(SlideIn, {
                offset: getSpacing("3x"),
                children: isHomepageRedesignV2 ? null : /*#__PURE__*/ _jsx(BestsellersBanner, {})
            }),
            /*#__PURE__*/ _jsx(BrandValueBannerWithV2Design, {}),
            /*#__PURE__*/ _jsx(SlideIn, {
                offset: getSpacing("3x"),
                children: /*#__PURE__*/ _jsx(WeMakeItSimpleBanner, {})
            }),
            /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
                children: /*#__PURE__*/ _jsx(BlogCarousel, {})
            }),
            /*#__PURE__*/ _jsx(SlideIn, {
                offset: getSpacing("3x"),
                children: /*#__PURE__*/ _jsx(BottomSignUpBanner, {})
            }),
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    });
};
